import { DataGrid } from "@mui/x-data-grid/DataGrid";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import React, { useState, useEffect } from "react";
import { SwitchProps } from '@mui/material/Switch';
import { EventsListItem, newEventInfo } from "../../data/eventInfo";
import {EventQuestionnaire, Question} from "../../data/eventQuestionnaire";
import { getEventInfo, saveEventInfo, deleteEventInfo, getEventById } from "../../services/EventInformation";
import {getEventQuestionnaire, saveQuestionnaireResponse} from "../../services/QnAAPI";
import {createStripeCheckoutSession, confirmStripePayment} from "../../services/StripeService"
import {
    Box,
    Button,
    Grid,
    IconButton,
    MenuItem,
    Modal,
    Pagination,
    Snackbar,
    Stack,
    Switch,
    Typography,
    FormControlLabel,
    Radio,
    RadioGroup
} from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import FormBox from "@mui/material/Box";
import "../admin/Event.css";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";
import CircularProgress from '@mui/material/CircularProgress';
import ViewListIcon from '@mui/icons-material/ViewList';
import SponsorsIcon from "@mui/icons-material/Star";
import SponsorshipTierIcon from "@mui/icons-material/Landscape";
import CommunicationIcon from "@mui/icons-material/Comment";
import AddIcon from "@mui/icons-material/Add";
import {useGlobal} from "../../utils/GlobalContext";



type ModalMode = "detail";
export default function Registration({
                                         onShowSessionsClick,
                                         onShowSponsorshipTiersClick,
                                         onShowSponsorsClick,
                                         onShowRegisterCLick
                                     }: {
    onShowRegisterCLick: (eventId: string) => void;
    onShowSessionsClick: (eventId: string) => void,
    onShowSponsorshipTiersClick: (eventId: string) => void,
    onShowSponsorsClick: (eventId: string) => void
}) {
    const [modelMode, setModelMode] = useState<ModalMode>("detail");
    const [eventsListItems, setEventsListItems] = useState<EventsListItem[]>([]);
    const [selectedRow, setSelectedRow] = useState<EventsListItem | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
    const [newFormValues, setNewFormValues] = useState(newEventInfo());
    const [formValues, setFormValues] = useState(newEventInfo());
    const [questions, setQuestions] = useState<Question[]>([]);
    const [questionsLoading, setQuestionsLoading] = useState(false);
    const [answers, setAnswers] = useState<{ [questionId: string]: any }>({});
    const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
    const [ticketType, setTicketType] = useState<string>('free');
    const { state } = useGlobal();
    const [error, setError] = useState<string | null>(null);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);


    useEffect(() => {

        const getEventInfo = async () => {
            // Call getEventById with the selected event's ID
            try {
                const event = await getEventById("08c8134b-6b93-43fa-b679-07bf98440b43");
                setFormValues(event);
                setIsModalOpen(true);
            } catch (error) {
                console.error("Error fetching event info:", error);
            }
        }
        getEventInfo();
    }, []);

    useEffect(() => {
        const checkPaymentStatus = async () => {
            const searchParams = new URLSearchParams(window.location.search);
            const sessionId = searchParams.get('session_id');
            const canceled = searchParams.get('canceled');

            if (canceled) {
                setError("Payment was canceled. Please try again if you wish to complete your registration.");
                // Clear the URL params to prevent showing the message again on refresh
                window.history.replaceState({}, document.title, window.location.pathname);
                return;
            }

            if (sessionId) {
                setIsProcessingPayment(true);
                try {
                    const result = await confirmStripePayment(sessionId);
                    if (result.success) {
                        window.location.href = `/registration-success?eventId=${result.eventId}`;
                    } else {
                        setError("Payment failed. Please try again.");
                        // Clear the URL params
                        window.history.replaceState({}, document.title, window.location.pathname);
                    }
                } catch (error) {
                    console.error("Error confirming payment:", error);
                    setError("An error occurred while processing your payment. Please try again.");
                    // Clear the URL params
                    window.history.replaceState({}, document.title, window.location.pathname);
                } finally {
                    setIsProcessingPayment(false);
                }
            }
        };

        checkPaymentStatus();
    }, []);

    const event = getEventById("08c8134b-6b93-43fa-b679-07bf98440b43");
    const ticketOption = { inputProps: { 'aria-label': 'Size switch demo' } };
    const userId = state.UserProfile.Id;
    const handleSaveResponses = async () => {
        if (!selectedEventId) return;


        const eventResponse = {
            eventId: "08c8134b-6b93-43fa-b679-07bf98440b43",
            userId: userId,
            submitted: new Date().toISOString(),
            checkIn: false,
            checkInTime: null,
            responses: questions.map((q) => ({
                questionId: q.id,
                answers: [
                    String(answers[q.id]) // ✅ stringified no matter what
                ]
            }))
        };

        try {
            console.log("Sending registration:", eventResponse);
            await saveQuestionnaireResponse(eventResponse);
            console.log("Response saved successfully");
        } catch (err) {
            console.error("Error saving response:", err);
        }
    };

    const handlePayment = async () => {
        try {
            setIsProcessingPayment(true);
            setError(null);

            // Questionnaire responses save
            await handleSaveResponses();

            // Create the Stripe checkout session
            const { CheckoutUrl } = await createStripeCheckoutSession(
                "08c8134b-6b93-43fa-b679-07bf98440b43",
                userId,
                formValues.Name,
                formValues.Price
            );

            // Redirect to Stripe checkout page
            window.location.href = CheckoutUrl;
        } catch (error) {
            console.error("Error during payment process:", error);
            setError("Failed to initiate payment. Please try again.");
        } finally {
            setIsProcessingPayment(false);
        }
    };

    useEffect(() => {
        const fetchQuestionnaire = async () => {
            try {
                const defaultEventId = "08c8134b-6b93-43fa-b679-07bf98440b43";
                setSelectedEventId(defaultEventId);
                setRegistrationModalOpen(true);
                setQuestionsLoading(true);
                setQuestions([]);
                setAnswers({});

                const data = await getEventQuestionnaire(defaultEventId);

                setQuestions(data.questions);

                const initialAnswers: { [key: string]: any } = {};
                data.questions.forEach((q) => {
                    initialAnswers[q.id] = q.default ?? "";
                });

                setAnswers(initialAnswers);
            } catch (error) {
                console.error("Error fetching questionnaire:", error);
            } finally {
                setQuestionsLoading(false);
            }
        };

        fetchQuestionnaire();
    }, []);

    interface column {
        field: string;
        headerName: string;
        width: number;
        editable?: boolean;
        renderCell?: (params: any) => JSX.Element;
    }



    const [statusValue, setStatusValue] = useState(modelMode === "detail" ? newFormValues.Status : formValues.Status);
    // Update statusValue when formValues or newFormValues change
    useEffect(() => {
        // Check if modelMode is "add", if so, use newFormValues, otherwise, use formValues
        const selectedValues = modelMode === "detail" ? newFormValues : formValues;

        // Check if selectedValues has a status value and set statusValue accordingly
        if (selectedValues && selectedValues.Status) {
            setStatusValue(selectedValues.Status);
        } else {
            // If there's no status value, set it to an empty string
            setStatusValue('');
        }
    }, [formValues, newFormValues, modelMode]);

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 8, mb: 2, ml: 4 }}>
                <Typography variant="h5" fontWeight="bold" color="black">
                    Register for Event
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 600,
                        backgroundColor: '#efefef',
                        border: '2px solid #1d1e1e',
                        borderRadius: '2rem',
                        px: 4, // padding left and right
                        pt: 4, // padding top
                        pb: 12, // ⬅️ extra padding bottom
                    }}
                >

                    {questionsLoading ? (
                        <Box display="flex" justifyContent="center">
                            <CircularProgress />
                        </Box>
                    ) : questions.length === 0 ? (
                        <Typography>No questions available for this event.</Typography>
                    ) : (
                        <form>
                            {questions.map((question, index) => (
                                <Box key={question.id} mb={3}>
                                    <Typography variant="h6" fontWeight="bold">
                                        Question {index + 1}
                                    </Typography>
                                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                                        {question.prompt}
                                        {question.isRequired && <span style={{ color: 'red' }}> *</span>}
                                    </Typography>

                                    {question.type === 'multiple_choice' && (
                                        <RadioGroup
                                            value={answers[question.id]}
                                            onChange={(e) =>
                                                setAnswers({ ...answers, [question.id]: e.target.value })
                                            }
                                        >
                                            {question.options.map((opt) => (
                                                <FormControlLabel
                                                    key={opt}
                                                    value={opt}
                                                    control={<Radio />}
                                                    label={<Typography fontWeight="bold" sx={{ color: 'black'}}>{opt}</Typography>}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}

                                    {question.type === 'true_false' && (
                                        <RadioGroup
                                            value={answers[question.id]}
                                            onChange={(e) =>
                                                setAnswers({ ...answers, [question.id]: e.target.value })
                                            }
                                        >
                                            <FormControlLabel
                                                value="true"
                                                control={<Radio />}
                                                label={<Typography fontWeight="bold" sx={{ color: 'black' }}>True</Typography>}
                                            />
                                            <FormControlLabel
                                                value="false"
                                                control={<Radio />}
                                                label={<Typography fontWeight="bold" sx={{ color: 'black' }}>False</Typography>}
                                            />
                                        </RadioGroup>
                                    )}

                                    {question.type === 'single_answer' && (
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            value={answers[question.id]}
                                            onChange={(e) =>
                                                setAnswers({ ...answers, [question.id]: e.target.value })
                                            }
                                            sx={{ backgroundColor: 'white', borderRadius: '12px' }}
                                        />
                                    )}

                                    {question.type === 'multiple_line' && (
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            value={answers[question.id]}
                                            onChange={(e) =>
                                                setAnswers({ ...answers, [question.id]: e.target.value })
                                            }
                                            sx={{ backgroundColor: 'white', borderRadius: '12px' }}
                                        />
                                    )}
                                </Box>
                            ))}
                            <Box sx={{ mt: 4, textAlign: 'center' }}>
                                {/* Ticket Option Switch */}
                                <Typography variant="h6" fontWeight="bold">
                                    Ticket Option
                                </Typography>
                                <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                    <Typography variant='h6' color={'black'}>Free</Typography>
                                    <div className='registration-switch'>
                                        <Switch
                                            checked={ticketType === 'paid'}
                                            onChange={(e) => setTicketType(e.target.checked ? 'paid' : 'free')}
                                        />
                                    </div>
                                    <Typography variant='h6' color={'black'}>Paid - ${formValues.Price}</Typography>
                                </Stack>

                                {/* Dynamic Benefits Display */}
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                    {ticketType === 'free' ? (
                                        <Box component="ul" sx={{
                                            pl: 2,
                                            textAlign: 'center',
                                            listStyleType: 'none',
                                            padding: 0,
                                            margin: 0
                                        }}>
                                            <Typography component="li" sx={{ mb: 1 }}>Meal Included</Typography>
                                            <Typography component="li" sx={{ mb: 1 }}>Access to sessions</Typography>
                                            <Typography component="li" sx={{ mb: 1, textDecoration: 'line-through'  }}>Appreciation bag</Typography>
                                            <Typography component="li" sx={{ textDecoration: 'line-through' }}>Exclusive networking event access</Typography>
                                        </Box>
                                    ) : (
                                        <Box component="ul" sx={{
                                            pl: 2,
                                            textAlign: 'center',
                                            listStyleType: 'none',
                                            padding: 0,
                                            margin: 0
                                        }}>
                                            <Typography component="li" sx={{ mb: 1 }}>Meal Included</Typography>
                                            <Typography component="li" sx={{ mb: 1 }}>Access to sessions</Typography>
                                            <Typography component="li" sx={{ mb: 1 }}>Appreciation bag</Typography>
                                            <Typography component="li">Exclusive networking event access</Typography>
                                        </Box>
                                    )}
                                </Box>

                                {/* Dynamic Button */}
                                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                    {ticketType === 'free' ? (
                                        <Button
                                            onClick={handleSaveResponses}
                                            variant="contained"
                                            disableElevation
                                            sx={{
                                                backgroundColor: '#06bb09 !important',
                                                color: 'black !important',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    backgroundColor: '#77dd77 !important',
                                                },
                                            }}
                                        >
                                            Submit Registration
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={handlePayment}
                                            variant="contained"
                                            disableElevation
                                            disabled={isProcessingPayment}
                                            sx={{
                                                backgroundColor: '#06bb09 !important',
                                                color: 'black !important',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    backgroundColor: '#77dd77 !important',
                                                },
                                                '&:disabled': {
                                                    backgroundColor: '#cccccc !important',
                                                    color: '#666666 !important'
                                                }
                                            }}
                                        >
                                            Pay Now (${formValues.Price})
                                        </Button>
                                    )}
                                </Box>

                                {error && (
                                    <Box sx={{ mt: 2, textAlign: 'center' }}>
                                        <Typography color="error" variant="body1">
                                            {error}
                                        </Typography>
                                    </Box>
                                )}

                                {isProcessingPayment && (
                                    <Box sx={{ mt: 2, textAlign: 'center' }}>
                                        <CircularProgress size={24} />
                                        <Typography variant="body1" sx={{ mt: 1 }}>
                                            Processing payment...
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </form>
                    )}
                </Box>
            </Box>
        </>
    );
}